"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jobStatusMentions = exports.senderMentionText = exports.recipientMentionText = void 0;
function recipientMentionText(kind) {
    switch (kind) {
        case 'note-mention':
            return 'mentioned you in a note';
        case 'note-edited':
            return 'edited your note';
        case 'note-reply':
            return 'replied to your note';
        case 'submission-status-request':
            return 'requested an update on the submission';
        case 'blacklist-request':
            return 'requested removal from email list';
        case 'job-update-active':
            return 'updated job status to Active';
        case 'job-update-archived':
            return 'Archived the job';
        case 'job-update-paused':
            return 'Paused the job';
        default:
            return '';
    }
}
exports.recipientMentionText = recipientMentionText;
function senderMentionText(kind) {
    switch (kind) {
        case 'note-mention':
            return 'mentioned in a note';
        case 'note-edited':
            return 'note edited';
        case 'note-reply':
            return 'note replied to';
        case 'submission-status-request':
            return 'submission status update requested';
        case 'blacklist-request':
            return 'removal from email list requested';
        default:
            return '';
    }
}
exports.senderMentionText = senderMentionText;
exports.jobStatusMentions = ['job-update-active', 'job-update-paused', 'job-update-archived'];
//# sourceMappingURL=user-mention.js.map